import {
  FormControl,
  FormHelperText,
  FormLabel,
  Typography,
} from '@material-ui/core'
import { forwardRef, useCallback } from 'react'
import { NumberFormatBase, NumberFormatBaseProps } from 'react-number-format'

import { useStyles } from './styles'

interface CurrencyInputProps
  extends Omit<NumberFormatBaseProps, 'getInputRef'> {
  label: string
  error?: string
  ref?: NumberFormatBaseProps['getInputRef']
}

function CurrencyInputComponent(
  { error, label, ...props }: CurrencyInputProps,
  ref: NumberFormatBaseProps['getInputRef'],
) {
  const classes = useStyles()

  const currencyFormatter = useCallback((value) => {
    if (!Number(value)) return ''

    const amount = new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL',
      currencyDisplay: 'code',
    })
      .format(value / 100)
      .replace('BRL', '')

    return `${amount}`
  }, [])

  return (
    <FormControl className={classes.treatmentCost} error={!!error}>
      <FormLabel>
        <Typography variant='subtitle2'>{label}</Typography>
        <div>
          <span>R$</span>
          <NumberFormatBase
            placeholder='000,00'
            format={currencyFormatter}
            getInputRef={ref}
            {...props}
          />
          <span>/ha</span>
        </div>
      </FormLabel>
      <FormHelperText>{error}</FormHelperText>
    </FormControl>
  )
}

export const CurrencyInput = forwardRef(CurrencyInputComponent)
